import icon from '../../../../img/size.png'
export function SizePopup(props) {

    const updateSize = (e, pos) => {
        if(e.target.value === 'change Material') {
            props.updateChoosedOptions({ plateMaterial: 'Regular' })
        } else {
            if(pos === 'front') {
                props.updateChoosedOptions({ plateSizeFront: e.target.value })
                checkBreakLine(e.target.value, 'front')
            } else {
                props.updateChoosedOptions({ plateSizeRear: e.target.value })
                checkBreakLine(e.target.value, 'rear')
            }

        }
    }
    const checkBreakLine = (value, pos) => {
        let findFrontSize, findRearSize
        if (pos === 'front') {
            findFrontSize = props.plateBuilder['plate-size'].find(item => item.size === value)
            findRearSize = props.plateBuilder['plate-size'].find(item => item.size === props.choosedOptions.plateSizeRear)
        } else {
            findFrontSize = props.plateBuilder['plate-size'].find(item => item.size === props.choosedOptions.plateSizeFront)
            findRearSize = props.plateBuilder['plate-size'].find(item => item.size === value)
        }
        findFrontSize?.break || findRearSize?.break ? props.updateChoosedOptions({ breakLine: 'true' }) : props.updateChoosedOptions({ breakLine: 'false' })
    }

    return (
        <div className="option-popup__wrapper">
            <div className="option-popup__close" onClick={() => props.closePopup(null)}></div>
            <div className="option-popup__title flex items-center">
                <figure className="option-popup__icon">
                    <img src={icon} alt='size icon' />
                </figure>
                <h4>Plate Size</h4>
            </div>
            <p>
                Select your plate size from the options below
            </p>
            <div className='option-popup__options'>
                {props.choosedOptions.frontPlate === 'true'  &&
                    <div className='option-popup__select'>
                        <label for="select1">Front Plate Size</label>
                        <select id="select1" onChange={(e) => updateSize(e, 'front')}>
                            <option value="0" disabled selected>Select Front Plate Size</option>
                            {props.plateBuilder['plate-size'].map((item) => {
                                const material = props.choosedOptions.plateMaterial !== 'null' ? props.choosedOptions.plateMaterial :  'Regular'
                                if ((props.choosedOptions.fontStyle !== "laser3d webfont" &&
                                    props.choosedOptions.fontStyle !== "Dome4D" &&
                                    props.choosedOptions.fontStyle !== "Dome5D") && item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") && item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) && item.material.includes(material) && !item.onlyRear) {
                                    return <option value={item.size} data-break={item.break} selected={item.size === props.choosedOptions.plateSizeFront}>{item.size}</option>
                                } else if ((props.choosedOptions.fontStyle === "laser3d webfont" ||
                                    props.choosedOptions.fontStyle === "Dome4D" ||
                                    props.choosedOptions.fontStyle === "Dome5D") && item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") && item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) && (item.material.includes("3D Domed") || item.material.includes("4D Raised") || item.material.includes("5D Raised")) && !item.onlyRear) {
                                    return <option value={item.size} data-break={item.break} selected={item.size === props.choosedOptions.plateSizeFront}>{item.size}</option>
                                }
                            })}
                            {props.choosedOptions.plateMaterial === 'Acrylic' &&
                            <option value="change Material">Don't see the size you need? Try our Standard plate material options.</option>}
                        </select>
                    </div>
                }
                {props.choosedOptions.rearPlate === 'true' &&
                    <div className='option-popup__select'>
                        <label for="select2">Rear Plate Size</label>
                        <select id="select2" onChange={(e) => updateSize(e, 'rear')}>
                            <option value="0" disabled selected>Select Rear Plate Size</option>
                            {props.plateBuilder['plate-size'].map((item) => {
                                const material = props.choosedOptions.plateMaterial !== 'null' ? props.choosedOptions.plateMaterial :  'Regular'
                                if ((props.choosedOptions.fontStyle !== "laser3d webfont" &&
                                    props.choosedOptions.fontStyle !== "Dome4D" &&
                                    props.choosedOptions.fontStyle !== "Dome5D") && item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") && item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) && item.material.includes(material) && !item.onlyRear) {
                                        return <option data-break={item.break} value={item.size} selected={item.size === props.choosedOptions.plateSizeRear}>{item.size}</option>
                                    } else if ((props.choosedOptions.fontStyle === "laser3d webfont" ||
                                    props.choosedOptions.fontStyle === "Dome4D" ||
                                    props.choosedOptions.fontStyle === "Dome5D") && item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") && item.typeOfTransport.includes(props.choosedOptions.typeOfTransport) && (item.material.includes("3D Domed") || item.material.includes("4D Raised") || item.material.includes("5D Raised")) && !item.onlyRear) {
                                        return <option data-break={item.break} value={item.size} selected={item.size === props.choosedOptions.plateSizeRear}>{item.size}</option>
                                    }
                            })}
                            {props.choosedOptions.plateMaterial === 'Acrylic' &&
                            <option value="change Material">Don't see the size you need? Try our Standard plate material options.</option>}
                        </select>
                    </div>
                }
            </div>
            <div className="option-popup__btn flex justify-center">
                <div className="btn" onClick={() => props.closePopup(null)}>CONTINUE</div>
            </div>
            {props.choosedOptions.categoryPlate.includes("standard") &&
             <div className="option-popup__switch-show">
                <h6>Don’t see the size you’re looking for?  </h6>
                <p>The sizes shown above are ‘Road compliant’ Standard sizes, but we can produce your number plates at a range of other sizes as part of our Show Plates range.</p>

                <div className="option-popup__btn flex justify-center">
                    <div className=" btn btn--with-border" onClick={() => props.updateChoosedOptions({ categoryPlate: 'show', sloganName: '', showBSAU: 'false'  })}>SWITCH TO SHOW PLATES</div>
                </div>
             </div>
           }
        </div>
    )
}